import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwQueryMetaData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, FlightSchoolReportsCourseCountsQueryEntity } from '../../../../../meta-data/app-meta-data.service';

@DwComponent({
  name: 'Report Course Stat Card',
  key: 'reportStatCourseCard',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.RoStudentCourseDetail,
})
@Component({
  selector: 'app-report-course-stat-card',
  templateUrl: './report-course-stat-card.component.html',
  styleUrls: ['./report-course-stat-card.component.scss']
})
export class ReportCourseStatCardComponent implements DwCardBaseComponent<any, FlightSchoolReportsCourseCountsQueryEntity> {
  cardConfig?: any;
  data?: FlightSchoolReportsCourseCountsQueryEntity;
  resolvedContext?: any;
  queryMetaData?: DwQueryMetaData;

  setupCard() {
   // throw new Error('Method not implemented.');
  }

  cardClick: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {

  }

  click() {
   // this.cardClick.emit(this.data);
  }
}
